
















































import Vue from 'vue'

export default Vue.extend({
  name: 'ModifierDialog',

  props: {
    mainTitle: {
      type: String,
      default: ''
    },
    activatorHint: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      isShow: false
    }
  },

  watch: {
    isShow: {
      handler(val) {
        this.$emit('update:activate', val)
      }
    }
  },

  methods: {
    update() {
      this.$emit('update')
      this.isShow = false
    }
  }
})
